// extracted by mini-css-extract-plugin
export default {"container":"LoadingLogo_container__v20AI","loadingImage":"LoadingLogo_loadingImage__mZ6MK","loading":"LoadingLogo_loading__rrsKD"};